<template>
  <div class="page">
    <header class="topbar">
      <button class="icon-btn" @click="$router && $router.back()">✕</button>
      <div class="title">企业信息</div>
      <button class="icon-btn"></button>
    </header>

    <main class="content">
      <section class="card company-head">
        <div class="company-name">{{robotInfo.organization_name}}</div>
        <div class="verify-row">
          <span class="verify-badge">✓ 已认证</span>
          <!-- <button class="link-btn">我也想认证</button> -->
        </div>
      </section>

      <!-- <section class="card">
        <div class="section-title">认证信息</div>
        <div class="field">
          <span class="label">企业简称</span>
          <span class="value">朵娜贝拉</span>
        </div>
        <div class="field">
          <span class="label">企业全称</span>
          <span class="value">朵娜贝拉（上海）网络科技有限公司</span>
        </div>
        <div class="field">
          <span class="label">经营类目</span>
          <span class="value">电商-食品/饮料/生鲜果蔬</span>
        </div>
      </section>-->

      <section class="card">
        <div class="section-title">{{robotInfo.organization_name}}</div>
        <!-- <div class="field">
          <span class="label">统一社会信用代码</span>
          <span class="value">91310117MA1J2W2C5E</span>
        </div>
        <div class="field">
          <span class="label">企业类型</span>
          <span class="value">有限责任公司(自然人投资或控股)</span>
        </div>
        <div class="field">
          <span class="label">企业成立日期</span>
          <span class="value">2018年05月07日</span>
        </div>
        <div class="field">
          <span class="label">企业营业期限</span>
          <span class="value">2038年05月06日</span>
        </div>
        <div class="field addr">
          <span class="label">企业地址</span>
          <span class="value">上海市松江区九亭镇洋河浜路58号4幢2层202</span>
        </div>-->
        <div class="field">
          <span class="label">客服名称</span>
          <span class="value">{{robotInfo.robot_name}}</span>
        </div>
        <div class="field">
          <span class="label">客服信息</span>
          <span class="value">{{robotInfo.robot_description}}</span>
        </div>
        <div class="field">
          <span class="label">企业名称</span>
          <span class="value">{{robotInfo.organization_name}}</span>
        </div>
        <div class="field range">
          <span class="label">经营范围</span>
          <div
            class="value range-text"
            :class="{expanded: showRange}"
          >{{robotInfo.organization_description}}</div>
          <button class="more-btn" v-if="!showRange" @click="toggleRange">展开</button>
          <button class="more-btn" v-else @click="toggleRange">收起</button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { selectApi as selectRobot } from "@/services/robot/index";
export default {
  name: "FairInfo",
  async created() {
    //取路由上的参数 /:robot_code
    const botCode = this.$route.params?.botCode;
    console.log("botCode:", botCode);
    if (!botCode) {
      this.$router.replace(`/pricing`);
      return;
    }
    //根据botCode获取bot信息，若不存在跳转到产品介绍页
    let botRes = await selectRobot({
      robot_code: botCode
    });
    if (botRes.code === 200 && botRes.data.length > 0) {
      this.robotInfo = botRes.data[0];
    } else {
      this.$router.replace(`/pricing`);
      return;
    }
  },
  data() {
    return {
      showRange: false,
      robotInfo: {}
    };
  },
  methods: {
    toggleRange() {
      this.showRange = !this.showRange;
    }
  }
};
</script>

<style scoped>
/* page layout */
.page {
  /* background: #f5f6f7; */
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica,
    Arial;
}
.topbar {
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.title {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}
.icon-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #666;
  padding: 6px;
}

.content {
  padding: 12px;
}
.card {
  background: #fff;
  border-radius: 8px;
  padding: 30px 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.company-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.company-name {
  font-size: 24px;
  color: #0a5aa6;
  font-weight: 700;
}
.verify-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.verify-badge {
  background: #e6f4ec;
  color: #2b8a4b;
  padding: 6px 10px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
}
.link-btn {
  background: transparent;
  border: none;
  color: #4a90e2;
  font-size: 13px;
}

.section-title {
  font-size: 15px;
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
}
.field {
  display: flex;
  justify-content: flex-start;
  padding: 20px 0;
  border-top: 1px solid #f0f0f0;
  line-height: 26px;
}
.field:first-of-type {
  border-top: none;
  padding-top: 0;
}
.label {
  color: #888;
  width: 35%;
  font-size: 13px;
}
.value {
  color: #333;
  width: 65%;
  font-size: 14px;
}
.addr .value {
  text-align: right;
}

.range {
  align-items: flex-start;
}
.range-text {
  width: 65%;
  /* text-align: right; */
  color: #333;
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.range-text.expanded {
  -webkit-line-clamp: 100;
}
.more-btn {
  background: transparent;
  border: none;
  color: #4a90e2;
  font-size: 13px;
  margin-top: 6px;
  width: 50px;
}

@media (min-width: 420px) {
  .page {
    max-width: 420px;
    margin: 0 auto;
  }
}
</style>